// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 590 ? "main" : chunkId) + "." + {"64":"4c1c41eaac8ee9d50572","590":"ad762350a2b85195612c"}[chunkId] + ".css";
};